import { render, staticRenderFns } from "./JinNangFiveSaleAndBuy.vue?vue&type=template&id=7d5ba304&scoped=true"
import script from "./JinNangFiveSaleAndBuy.vue?vue&type=script&lang=js"
export * from "./JinNangFiveSaleAndBuy.vue?vue&type=script&lang=js"
import style0 from "./JinNangFiveSaleAndBuy.vue?vue&type=style&index=0&id=7d5ba304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5ba304",
  null
  
)

export default component.exports